import { h } from 'preact';
import cx from 'classnames';

import { Column, ContainerFluid, Row } from '@cube/layout';

import { getCommonProps } from '../../../../../lib/page';
import { SadlibAd } from '../../../../pieces/sadlib-ad';
import { Footer as DesktopFooter, Header as DesktopHeader } from '../../../shared/desktop';

import pageStyles from '../../../pageStyles.less';
import style from '../../shared/style.less';

export const Desktop = ({ pageConfig, ...props }) => (
	<ContainerFluid class={cx(pageStyles.fluidPageNoPadding, style.joinClass)}>
		<DesktopHeader pageConfig={pageConfig} {...props} />
		<div class={cx(style.section, style.sectionDesktop, pageStyles.responsivePage)}>
			<Row class={style.adWrapper}>
				<Column>
					<SadlibAd id="sc_onlineclass_player_top" type="desktopBanner" />
				</Column>
			</Row>
			<Row class={style.embedWrapper}>
				<Column class={style.column}>
					<div
						className={style.embedTarget}
						id="getSetUpEmbedTarget"
					/>
				</Column>
			</Row>
			<Row class={style.adWrapper}>
				<Column>
					<SadlibAd id="sc_onlineclass_player_bottom" type="desktopBanner" />
				</Column>
			</Row>
		</div>
		<DesktopFooter pageConfig={pageConfig} {...getCommonProps(props)} />
	</ContainerFluid>
);
